import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { GroupAnswerViewItem } from "../../../../../../../service/group";

interface ListItemProps {
    item: GroupAnswerViewItem;
    current?: boolean;
    onSelect: (val: GroupAnswerViewItem) => void;
}

export default function ListItem({
    item,
    current = true,
    onSelect
}: ListItemProps) {
    return (
        <div
            className={classNames(style.root, { [style.current]: current })}
            role="button"
            onClick={() => onSelect(item)}>
            <div className={style.header}>
                <span>{item.groupName}</span>
                <span className={style.state}>已参与</span>
            </div>

            <div className={style.content}>{item.taskName}</div>

            <div className={style.footer}>
                <div>小组成员人数（{item.groupCount || 0}）</div>
                <div>组长：{item.groupLeaderName}</div>
            </div>
        </div>
    );
}
